// API Configuration
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://web-production-df92d.up.railway.app';

// Log API URL for debugging
console.log('🔗 API Base URL:', API_BASE_URL);
console.log('🌍 Environment:', import.meta.env.MODE);
console.log('🚀 Production:', import.meta.env.PROD);

export default API_BASE_URL;

// Helper functions for API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...options.headers,
    },
    mode: 'cors',
    ...options,
  };

  try {
    console.log('API Call:', url, defaultOptions);
    const response = await fetch(url, defaultOptions);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
        url: url,
        requestBody: defaultOptions.body
      });
      
      let errorMessage = `HTTP error! status: ${response.status}`;
      let errorData = null;
      
      try {
        errorData = JSON.parse(errorText);
        console.error('Parsed Error Data:', errorData);
        
        if (errorData.detail) {
          if (Array.isArray(errorData.detail)) {
            // Pydantic validation errors - format them nicely
            errorMessage = errorData.detail.map(err => {
              const field = err.loc ? err.loc.join('.') : 'field';
              return `${field}: ${err.msg}`;
            }).join(', ');
          } else {
            errorMessage = errorData.detail;
          }
        }
      } catch (e) {
        // If not JSON, use the text
        if (errorText) {
          errorMessage = errorText;
        }
      }
      
      // Throw the original error data for better debugging
      const error = new Error(errorMessage);
      error.response = { status: response.status, data: errorData };
      throw error;
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', {
      url,
      error: error.message,
      stack: error.stack
    });
    throw error;
  }
};

// Specific API endpoints
export const API_ENDPOINTS = {
  // Health
  HEALTH: '/api/health/',
  HEALTH_DETAILED: '/api/health/detailed',
  
  // Detection & Analysis
  DETECT: '/api/detect',
  ANALYZE_BATCH: '/api/analyze_batch',
  ANALYSIS_STATUS: (taskId) => `/api/analysis_status/${taskId}`,
  ANALYSIS_RESULTS: (taskId) => `/api/analysis/results/${taskId}`,
  EXPORT_PRODUCTS: '/api/export_products',
  
  // Offers
  OFFERS: '/api/offers/',
  OFFERS_CREATE: '/api/offers/create',
  OFFERS_GET: (offerId) => `/api/offers/${offerId}`,
  OFFERS_SUMMARY: (offerId) => `/api/offers/${offerId}/summary`,
  OFFERS_PRODUCTS: (offerId) => `/api/offers/${offerId}/products`,
  OFFERS_PUBLISH: (offerId) => `/api/offers/${offerId}/publish`,
  OFFERS_PROCESS: '/api/offers/process',
  OFFERS_START_PROCESSING: (offerId) => `/api/offers/${offerId}/process`,
  OFFERS_STATUS: (jobId) => `/api/offers/process/${jobId}/status`,
  OFFERS_RESULTS: (jobId) => `/api/offers/process/${jobId}/results`,
  OFFERS_NEW: '/api/offers/create',
  
  // Products
  PRODUCTS: '/api/products/',
  PRODUCTS_BULK: '/api/products/bulk-action',
  
  // Merchants
  MERCHANTS: '/api/merchants/',
  
  // Cities
  CITIES: '/api/cities/',
  
  // Auth
  LOGIN: '/api/auth/login',
  LOGOUT: '/api/auth/logout',
  ME: '/api/auth/me',
};